<template>
<!--审定验收管理办法or标准-->
  <div class="article-list certificate">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <!-- 新增资讯内容 -->
    <section>
      <!-- <div class="banner"></div> -->
      <div class="page-content">
        <breadcrumb :list="[{title: title}]" />
        <div class="content-title page-title-red">{{ title }}</div>
        <dashed-list :list="articleList" type="img" :link="`/service/article-detail?type=${pageType}&artId=`" />
        <div class="pagination">
          共{{ total }}条
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="9"
            :pager-count="5"
            background
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import headerCmp from "@/components/common/header.vue"
  import menuCmp from "@/components/common/navMenu.vue"
  import footerCmp from "@/components/common/footer.vue"
  import Breadcrumb from "./Breadcrumb.vue"
  import DashedList from "@/components/DashedList.vue"
  import { getNewsList } from "@/api/news.js";

  export default{ 
    data(){ 
      return{ 
        title: ['标准', '审定验收管理办法'][this.$route.query.type],
        pageType: this.$route.query.type,
        articleList: [],
        total: 0,
        pageNum: 1,
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp,
      Breadcrumb,
      DashedList
    },
    methods:{ 
      handleCurrentChange(v) {
        this.pageNum = v;
        this.getContent();
      },
      getContent(){
        getNewsList({
          categorys: ['标准', '办法'][this.pageType],
          pageIndex: this.pageNum,
          pageSize: 9,
        }).then(res=>{
          this.articleList = res.data.list;
          this.total = res.data.total;
        });
          // this.articleList = [{
          //     title: '中国田径场馆 & 北京市朝阳区',
          //     id: 1,
          //     date: '2028-1-20' 
          // }, {
          //     title: '中国田径场馆 & 北京市朝阳区',
          //     id: 2,
          //     date: '2028-1-20' 
          // }, {
          //     title: '中国田径场馆 & 北京市朝阳区',
          //     id: 3,
          //     date: '2028-1-20' 
          // }, {
          //     title: '中国田径场馆 & 北京市朝阳区',
          //     id: 4,
          //     date: '2028-1-20' 
          // }, {
          //     title: '中国田径场馆 & 北京市朝阳区',
          //     id: 5,
          //     date: '2028-1-20' 
          // }];
      }
    },
    mounted(){ 
        this.getContent();
    }
  }
</script>

<style lang="scss" scoped>
</style>